import React from 'react';
import { meetingRenew } from 'api/zoom';
import { TServerRoomInfo } from 'types/zoom';
import { getMeetingUuid } from 'utils/sessionStorage';
import { ZOOM_AUTO_REFRESH_INTERVAL } from 'constants/common';

const useProviderMeetingInfo = (
    sessionKey?: string,
    autoRefresh?: boolean,
    refreshTime?: number,
): [TServerRoomInfo | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TServerRoomInfo>();
    const autoRef = React.useRef<NodeJS.Timeout | null>(null);
    const fetchData = async () => {
        const uuid = getMeetingUuid();
        if (loading || !sessionKey || !uuid) return;
        try {
            setLoading(true);
            const result = await meetingRenew(`${sessionKey}`, uuid);
            if (!result.error) {
                const resData = result?.data?.data || undefined;
                setData(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        if (!sessionKey) {
            return;
        }
        const _fetchData = async () => {
            const uuid = getMeetingUuid();
            if (loading || !sessionKey || !uuid) return;
            try {
                setLoading(true);
                const result = await meetingRenew(`${sessionKey}`, uuid);
                if (!result.error) {
                    const resData = result?.data?.data || undefined;
                    setData(resData);
                }
                // setLoading(false);
            } catch (e) {
                console.error(e);
            }
            setLoading(false);
        };
        if (sessionKey) {
            setData(undefined);
            _fetchData();
        }
        if (autoRefresh) {
            autoRef.current = setInterval(() => {
                _fetchData();
            }, refreshTime || ZOOM_AUTO_REFRESH_INTERVAL);
        }
        return () => {
            if (autoRef.current) {
                clearInterval(autoRef.current);
            }
        };
    }, [sessionKey, autoRefresh, refreshTime]);

    return [data, loading, fetchData];
};

export default useProviderMeetingInfo;
